import { useContext } from 'react';
import { MeuPlanoContextData } from '../types/context';
import { MeuPlanoContext } from '../contexts/MeuPlanoContext';

export const useMeuPlano = (): MeuPlanoContextData =>
  useContext(MeuPlanoContext);
